import React, {useEffect} from "react";
import { Col, Row, Alert } from "antd";
import { FormularioLogin } from "../components/FormularioLogin";
import "../css/Login.css";
import logo from "../assets/LOGO_UTESC.webp";
import { HeaderAspirante } from "../components/HeaderAspirante";
import Cookies from 'universal-cookie';

document.title = 'Examen diagnóstico UTEsc'

const Login = () => {

  const cookies = new Cookies();
  cookies.remove('pk_aspirante', { path: "/" })
  cookies.remove('fk_carrera', { path: "/" })

  localStorage.removeItem("materiaContestada");

  return (
    <div className="fondo-blanco">
      <HeaderAspirante />

      <Row className="login-centrado">
        <Col flex={1}></Col>
        <Col flex={2} className="contenedor-login">
          {/* esto es lo importante */}
          {/* <div className="site-card-border-less-wrapper">
            <Card title="Inicia sesión para continuar" bordered={true}>
              <Row> */}
          <Col flex={1}>
            <div className="div-logo-login">
              <img src={logo} className="logo-login" />
            </div>
          </Col>
          <Col flex={1}>
            <Row justify="center">
              <Col xxl={12} sm={12}>
                <FormularioLogin />
              </Col>
            </Row>
          </Col>
          {/* </Row>
            </Card>
          </div> */}
        </Col>
        <Col flex={1}></Col>
      </Row>
    </div>
  );
};

export default Login;
